import { Auditable, QueryParams, SortParams } from "..";

export interface ShippingMethod extends Auditable {
    name: string;
}

export const DefaultShippingMethodQueryParams: QueryParams = {
    name: "",
};

export const DefaultShippingMethodSortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};
